// extracted by mini-css-extract-plugin
export default {"taskChipWrapper":"assignment-card_taskChipWrapper__Yn3xg"};